import { IHandlers } from "src/services/ApiClient";
import { IControlError } from "../core/Controls";
import { PdErrors } from "../core/modal/CommentModal";
import { ErrorField } from "../core/validation/validate";
import { scrollPosition } from "../libs/helpers/Utils";
import { I18NString } from "src/components/Utils";
import { AxiosInstance, ResponseType } from "axios";

type statuses = "working" | "suspended";
type appointedStatuses = "appointed" | "confirmed" | "refused";
type Dictionary<TValue> = StringDictionary<TValue> & NumberDictionary<TValue>;
type extKey = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 14 | 18

interface StringDictionary<TValue> {
    [key: string]: TValue 
}

interface NumberDictionary<TValue> {
    [key: number]: TValue
}

interface form {
    sender_name: null,
    sender_email: null,
    sender_position: null,
    sender_phone: null,
    accept: false,
    comment: null,
}

interface ApiProperties {
    FileFormats?: {
        Image?: Array<string>,
        PDF?: Array<string>
    };
    actionUrl?: string;
    companiesApi?: string;
	contractUrl?: string;
	countriesUrl?: string;
	filesUrl?: string;
    projectsApi?: string;
    setValueUrl?: string;
	setPDFUrl?: string;
    urlApi?: string;
    userApi?: string;
    masterMentorURL?: string;
	specialistUrl?: string;
    mentorUrl?: string;
    lock?: boolean;
	options?: {
        apiUrl?: string;
        apiUser?: string;
		baseUrl?: string;
        companyUrl?: string;
        countriesUrl?: string;
        masterMentorURL?: string;
        mentorUrl?: string;
		specialistUrl?: string;
        filesUrl?: string;
		form_type: string;
		process_id: string;
		projectsApi?: string;
        token?: string;
        valuesId?: string;
		[key: string]: string;
	},
	adminRequest?: (comment: string, process_id: number, handlers: IHandlers) => void;
	getDynamicOptions?: (handlers: IHandlers, selectType: string) => void;
	deleteForm?: (form_type: string, process_id: number, handler: IHandlers) => void;
	getAppointedStatus?: (process_id: number, handler: IHandlers) => void;
    sendAdditional?: (handler: IHandlers) => void;
    sendDocument?: (handler: IHandlers, form?: form, sendType?: string, trailingSlash?: boolean) => void;
    sendRevoke?: (handler: IHandlers, form?: form) => void;
    sendPDF?: (handler: IHandlers) => void;
    loadPDF?: (handler: IHandlers) => void;
    loadContract?: (process_id: number, handlers: IHandlers) => void;
    deleteValues?: (handler: IHandlers) => void;
    cloneRequest?: (handler: IHandlers) => void;
    sendValues?: (handler: IHandlers) => void;
	send?: () => void;
	replyResolve?: (form_type: string, process_id: number, resolved: boolean, handler: IHandlers) => void;
	respondRequest?: (message: string, process_id: number, handlers: IHandlers) => void;
	moduleApi?: {
		uploadFile: ({
			apiUrl, file, fileId
		}: { apiUrl: string, fileId: string, file: File }, handler: IHandlers) => void;
		deleteFile: ({ apiUrl }: { apiUrl: string }, handler: IHandlers) => void;
        get: (url: string, query: any, handlers: IHandlers) => void;
        getControl: (url: string, query: any, handlers: IHandlers) => void;
        getFileArrayBuffer: (url: string, query: any, handlers: IHandlers) => void;
        getFileBlob: (url: string, query: any, handlers: IHandlers) => void;
        getFileByUrl: (url: string, responseType: ResponseType, handlers: IHandlers) => void;
        getInstance: (handler: IHandlers) => void;
        instance: AxiosInstance;
        post: (url: string, request: any, handlers: IHandlers) => void;
		customPostRequest?: (handler: IHandlers) => void;
	}
}
export interface IControlSchema {
	urlParams?: { [p: string]: string };
	fixedValueWithCalculate: any;
	controls?: Array<any>;
	id: string;
	type: string;
	contentNumb: string;
	disableNumber?: boolean;
	title: I18NString;
	required: boolean;
	viewableFor?: Array<string>;
	visible?: boolean;
	rule?: {
		targetInColumn: any;
		controlTargetId: string;
		option: any;
		value: string;
	};
	requiredRule?: {
		type: 'OR' | 'AND';
		rules: [
			{
				controlTargetId: string;
				option: any;
				value: string;
			}
		]
	}
	visibleRule?: {
		type: 'OR' | 'AND';
		rules: [
			{
				controlTargetId: string;
				option: any;
				value: string;
			}
		]
	}
	fill_rule?: {
		value: any;
		option: any;
		controlTargetId: any;
		controlSourceId: any;
	}
	rule_operation?: string;
	disabled?: boolean;
	defaultValue?: any;
	fixedValue?: any;
	countries?: Array<any>;
	flows?: Array<any>;
	changed?: any;
	columns?: Array<any>;
	extra?: any;
	value?: any;
	controlValue?: any;
	minLength?: number;
	maxLength?: number;
	blockedIfEmpty?: {
		id: string;
		errorMessage: string;
	};
	valueFromField?: {
		from: {
			[key: string]: {
				field: string;
				grid?: string;
				type: string | number;
			};
		};
		result: string;
	};
	widget?: {
		selectType?: string;
		dynamicType?: string;
	};
	template?: {
		templateTitle: string;
		columns?: Array<any>;
	};
}

interface ISection {
	id: string;
	title: I18NString;
	parent?: string;
	children?: Array<ISection>;
	controls: Array<IControlSchema>;
	extra?: {
		visible: boolean;
	};
	$$timestamp?: number;
}

export interface Schema {
	allow_defence?: boolean,
	allVisited?: boolean,
	appointedStatus?: appointedStatuses;
	changed_controls?: Array<string>,
	checkedPanel?: Array<string>,
	cities?: Array<any>,
	clusters?: Array<any>,
	companies?: Array<any>,
	company?: any,
	control_mode?: any,
	countries?: Array<any>,
	countToSend?: number,
	directions?: any,
	direction_id?: any,
	dynamicOptions?: Record<string, Array<any>>
	errors: Dictionary<any | undefined>,
	flows?: any,
    form: any,
	form_kind?: any,
	form_type?: string,
    forms?: Array<any>,
	formUid?: string,
	history?: Array<any>,
	initialEntity?: any,
	listUserForms?: Array<any>,
	loaders: any,
	mentors?: {
		slave: Array<any>,
	},
	mentor_confirmed?: boolean,
    mode?: statuses,
    modeLoaded?: boolean,
    pagination?: any,
	process?: {
        all: Array<any>,
    },
	process_id?: number,
	process_stage?: number,
	projects?: Array<any>,
	readonly?: boolean,
	registration_date?: string,
    registration_number?: string,
	request_id?: any,
	section: string,
	selectedCompany?: any,
	senderData?: any,
	status?: number,
	tags?: Array<any>,
	typeForm?: string,
	user?: any,
    values: Array<any>,
    version?: number,    
    visited?: Dictionary<boolean>,
	votesResult?: any,
}
interface params {
	process_id: number | string;
	form_type: string;
}

interface initialRule {
	valueName: string,
	callback: () => void
}

interface extRules {
	ALLOWED_FIELDS?: {
		verificator?: Record<extKey, Array<string>>
	}
	ActionsDefaultState?: {
		comment?: string,
		lastComment?: string,
		revoke?: string,
		send?: string,
		visible?: Array<string>,
		question?: string,
		respondRequest?: string,
		writtenReply?: string
	},
	ActionsRules?: {
		user?: Record<extKey, extRules["ActionsDefaultState"]>,
		verificator?: Record<extKey, extRules["ActionsDefaultState"]>,
	},
	FORM_BUTTONS?: {
		send?: string,
		revoke?: string,
		withdraw?: string
	},
	FORM_LABELS?: Record<extKey, string>,
	FORM_STATUS?: Record<extKey, string>,
	HOST?: string,
	INITIAL_RULES?: {
		set_email?: initialRule,
		set_full_name?: initialRule,
		set_phone?: initialRule
	}
	PAGINATION?: {
		page?: number,
		pagesize?: number,
		total?: number,
	},
	URL_PREFIX?: string,
	CONTRACT_URL?: string,
	PDF_URL?: string,
	MENTORS_URL?: string,
	SITE_PREFIX?: string,
	page?: number,
	pagesize?: number,
	getFormSubtitle?: (typeForm: string, values: any[]) => string,
	getFormTitle?: (params: params) => string,
	FORMS_URL?: (params: params) => string
}

export interface Props {
	schema: Schema;
	loaders: {[k: string]: boolean};
	api: ApiProperties;
	moduleApi: ApiProperties["moduleApi"];
	extRules: extRules;
	process_id: number;
}

export interface State {
	errorField: ErrorField;
	pd_field_errors?: PdErrors;
	loader: boolean;
	func: (open) => void;
	anchorTo: scrollPosition
	anchoredTo: scrollPosition
}

export const DefaultState: State = {
	errorField: null,
	pd_field_errors: null,
	loader: false,
	func: null,
	anchoredTo: {
		controlId: undefined,
		sectionId: undefined,
	},
	anchorTo: {
		controlId: undefined,
		sectionId: undefined,
	},
};



export interface RequestProps {
	// параметры запроса, включают в себя id запроса (например, 2259) и тип формы (например, actualizeRequest)
	params?: params;
	// Actions - Устанавливает секцию по ее id. При открытии/создании формы устанавливается нулевая секция из массива. Далее по клику на ссылку в сайдбаре соответствующая по id
	setSection: (sectionId: string) => void;
	// Actions - Получает все формы и рендерит их список на главной странице
	// TODO getForms: (page: number, pagesize: number, clusters?: Array<string>) => void;
	getForms: any;
	// Actions - Записывает значение поля в общий массив значений
	addValue: (controlId: string, value: any, refresh: boolean, action?: string) => void;
	// Actions - Метод используется в гриде (перехват ниже в gridRefreshValue). При наличии в гриде в разделе extra свойства refresh_value добавляется кнопка, которая обновляет значение свойства с указанным id путем post-запроса
	refreshValue: (controlId: string) => void;
	// Actions - Сохраняет значение файла в общий массив значений
	addFile: (controlid:string, value: any) => void;
	// Actions - Получает объект с историей изменений формы 
	getHistory: (processId: string | number) => void;
	// Actions - Отрабатывает на кнопке Назначить мне в regm - меняется статус заявки (на рассмотрении > в работе) и присваивается ментору
	getAppointed?: (processId: number) => void; 
	// Actions - Сохраняет панели, с которыми пользователь взаимодействовал, в массив
	checkedPanel: (panelId: string, checked: boolean, error: IControlError | undefined) => void;
	// Actions - Считает количество попыток отправки форрмы
	incrimentToSend: () => void;
	// Actions - Открывает форму с соответствующим типом и id
	loadFrom: (formType: string, processId: number | string) => void;
	// Actions - Не используется?? Копирует значение из source в target 
	copyValue: (sourceId: string, targetId: string) => void;
	// Actions - Не используется
	recal: () => void;
	// Набор секций для каждой формы
	sections: Array<ISection>;
	// Actions - Проверяет, было ли взаимодействие с полем
	markVisited: (id: string) => void;
	// Actions - Фиксирует ошибку в поле
	setError: (id: string, error: IControlError) => void;
	// Actions - Все поля формы отмечаются как посещенные
	markAllVisited: () => void;
	// Блок с кнопками-экшенами формы
	extActions: any;
	// Отзывает заявку
	onRevoke?: (comment?: boolean, personal?: boolean, title?: string) => void;
	// Формирует ПДФ
	onReportPDF?: () => void;
	// Позволяет скачать ПДФ
	onLoadPDF?: () => void;
	// Позволяет скачать проект соглашения
	onLoadContract?: () => void;
	// Проверяет форму и отправляет ее 
	onValidateAndSend?: () => void;
	// Копирует заявку
	onCopy?: () => void;
	// Отправляет документы 
	onDocument?: (property: {
		comment?: boolean;
		personal?: boolean;
		title?: string;
		sendType?: string;
		returnUrl?: string;
		callback?: () => void;
		formKind?: number;
		notifyMessage?: string;
	}) => void;
	// 
	onReturn?: (props: { customLink?: string; formKind?: number }) => void;
	// Удаляет заявку
	onDelete?: () => void;
	// Отправляет дозапрос
	onAddition?: () => void;
	// 
	onDraft?: any;
	// Показывает модалку с последним комментарием
	onLastComment?: (lastComment?: string, lastCommentColor?: string) => void;
	// Отзывает заявку со стороны ментора
	// onAcceptMentorProcess?: (processId?: string, accept?: boolean, formType?: string, comment?: string) => void;
	onAcceptMentorProcess?: any,
	// TODO: Убрать как сделают одинаковые запрос для динамического списка черех json схему!
	setDynamicOption?: <T extends object>(object: T) => void;
	// Показывает попап с уведомлением
	notify?: (message: any, accept?: any, headerTitle?: string) => void;
	// Показывает попап с подтверждением
	confirm?: (message: string, accept: any, headerTitle?: string) => void;
	remoteControls?: {
		[key: string]: (...args: any) => any
	}
}
